import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({

  state: {
    // 存储token
    Authorization: sessionStorage.getItem('Authorization') ? sessionStorage.getItem('Authorization') : '',
    refresh_token: sessionStorage.getItem('refresh_token') ? sessionStorage.getItem('refresh_token') : '',
  },

  mutations: {
    // 修改token，并将token存入sessionStorage
    changeLogin (state, user) {
        state.Authorization = user.Authorization
        state.refresh_token = user.refresh_token;
        sessionStorage.setItem('Authorization', 'Bearer '+state.Authorization);
        sessionStorage.setItem('refresh_token', state.refresh_token);
    },
    DelToken(state){
        state.Authorization = '';
        sessionStorage.clear();
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js